import * as React from 'react';

import Radio from 'af-components/Controls/Radio';

import styles from './styles.module.scss';

type Props = {
	selected: boolean;
	setSelected: (selected: boolean) => void;
};

const BooleanFilter: React.FC<Props> = ({ selected, setSelected }) => {
	const onCheck = React.useCallback(() => {
		setSelected(!selected);
	}, [selected, setSelected]);

	return (
		<div className={styles['boolean-field']}>
			<Radio checked={selected} label="Yes" onCheck={onCheck} />
			<Radio checked={!selected} label="No" onCheck={onCheck} />
		</div>
	);
};

export default React.memo(BooleanFilter);
